import React, { Component } from 'react';
import { Button, Panel } from 'react-bootstrap';
import { DropdownList } from 'react-widgets';
import { withTranslation } from 'react-i18next';
import ChildFormList from './ChildFormList';
import FormAnalyticsComponents from '../individualConsultationFormsAnalytics';

class Forms extends Component {
	constructor(props) {
		super(props);
		this.handleViewSwitch = this.handleViewSwitch.bind(this);
		this.handleChildSelect = this.handleChildSelect.bind(this);

		const { children } = this.props.parent;
		const firstChild = children && children[0];
		this.state = {
			selectedChildId: firstChild && firstChild.id,
			selectedView: 'list'	// list or charts
		};
	}

	handleViewSwitch() {
		this.setState({
			selectedView: this.state.selectedView === 'list' ? 'charts' : 'list'
		});
	}

	handleChildSelect(value) {
		this.setState({ selectedChildId: value.id });
	}

	render() {
		const { parent, childDashboardComponentName, t } = this.props;
		const { selectedChildId, selectedView } = this.state;

		let viewComponent = null, switchViewResource = '';
		const childComponent = <div>
			{parent.children && parent.children.length > 0 && (parent.children.length > 1 ?
				<DropdownList style={{ marginBottom: '10px' }} data={parent.children} defaultValue={parent.children[0]} textField='fullName' valueField='id' onChange={this.handleChildSelect} /> :
				<h4 style={{ textAlign: 'center' }}>{parent.children[0].fullName}</h4>)}
		</div>;

		switch (selectedView) {
			case 'list':
				switchViewResource = 'Forms_View_Charts';
				viewComponent = <div>{selectedChildId && <ChildFormList childId={selectedChildId} />}</div>;

				break;
			case 'charts':
				switchViewResource = 'Forms_View_List';
				viewComponent = <div>{selectedChildId && FormAnalyticsComponents(childDashboardComponentName, { childId: selectedChildId })}</div>;

				break;
		}

		return <Panel>
		<Panel.Body>
			{childDashboardComponentName && <div style={{ marginBottom: '10px' }}><Button bsStyle='success' onClick={this.handleViewSwitch}>{t(switchViewResource)}</Button></div>}
			{childComponent}
				{viewComponent}
			</Panel.Body>
		</Panel>;
	}
}

export default withTranslation()(Forms);
